import { VBox } from "@ui/box/Box";
import { Rows } from "@ui/table/Rows";
import { TFeaturedComponent } from "src/Featuresmap";
import { GD } from "src/GD";
import { IClient } from "src/services/ClientService";
import { EventClip } from "src/view/conponents/EventClip";

export interface IClientPageEventsProps {
	client: IClient;
}


export const ClientPageEvents: TFeaturedComponent<IClientPageEventsProps> = ({ client }: IClientPageEventsProps) => {
	const [res, _1, _2, busy] = GD.REQ_CLIENT_EVENTS.useRequest(undefined, {
		clientID: client.id,
	});

	const events = res?.data;

	return (
		<VBox>
			<Rows
				busy={busy}
				error={res?.error}
				data={events ?? []}
				itemType="event"
				order={["id", "user_id", "user_name", "action", "created_at"]}
				cellFactory={(_row, cell, _index, _key, _name, _sx, _expanded, _rowID) => {
					return { content: cell };
				}}
				onExpand={row => <EventClip id={row.id} />}
			/>
		</VBox>
	);
};

ClientPageEvents.feature = "events_list";
